export function filterNullValuesFromChartData<T extends Record<string, any>>(
    data: T[],
): T[] {
    return data.map((item) => {
        const filteredItem = { ...item };

        Object.keys(filteredItem).forEach((key) => {
            if (filteredItem[key] === null) {
                delete filteredItem[key];
            }
        });

        return filteredItem;
    });
}

export function formatCurrency(value: number) {
    const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
    return formatter.format(value);
}

export function formatTooltipData(items: Array<{ label: string; value: any }>) {
    return items
        .filter((item) => item.value != null && item.value !== "$NaN")
        .map((item) => ({
            label: item.label,
            value: item.value,
        }));
}
